class SideCartItem extends HTMLElement {
  constructor() {
    super();

    this.lineItemKey = this.getAttribute('line-item-key');
    this.variant_id = this.getAttribute('variant-id');
    this.itemCount = Number(this.getAttribute('item-count'));

    this.sideCart = this.closest('side-cart');

    this.querySelector('.cart-item-delete').addEventListener('click', this.clearLineItem.bind(this));
    this.querySelector('.cart-item-qty-plus').addEventListener('click', this.addQty.bind(this));
    this.querySelector('.cart-item-qty-minus').addEventListener('click', this.minusQty.bind(this));
  }

  updateCart(updates) {
    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates }),
    })
      .then((response) => response.json())
      .then((cart) => {
        const updatedItem = cart.items.find((i) => i.id == this.variant_id);
        if (updatedItem) this.itemCount = updatedItem.quantity;
        this.sideCart.cart = cart;
        this.sideCart.buildCart(cart);
      });
  }

  // Prefer precise updates by line-item key to avoid variant-level merges/splits
  changeLineItem(quantity) {
    const clampedQty = Math.max(0, Number(quantity) || 0);
    // If we have a line key, target the exact line
    if (this.lineItemKey) {
      this.sideCart.classList.remove('loaded');
      fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: this.lineItemKey, quantity: clampedQty }),
      })
        .then((response) => response.json())
        .then((cart) => {
          const updatedItem = cart.items.find((i) => i.key === this.lineItemKey);
          this.itemCount = updatedItem ? updatedItem.quantity : 0;
          this.sideCart.cart = cart;
          this.sideCart.buildCart(cart);
        });
      return;
    }

    // Fallback: update by variant id if no key present
    let updates = {};
    updates[this.variant_id] = clampedQty;
    this.sideCart.classList.remove('loaded');
    this.updateCart(updates);
  }

  addQty() {
    this.changeLineItem((this.itemCount || 0) + 1);
  }

  minusQty() {
    this.changeLineItem(Math.max(0, (this.itemCount || 0) - 1));
  }

  clearLineItem() {
    this.changeLineItem(0);
  }
}

customElements.define('side-cart-item', SideCartItem);

class SideCart extends HTMLElement {
  constructor() {
    super();

    this.drawer = this.closest('sidecart-drawer');
    // console.log(this.drawer);

    this.itemTemplate = this.querySelector('template#side-cart-item'); // <- Put your template code for your side cart item here
  }

  renderSideCartItem(context = {}) {
    const template = this.itemTemplate;

    // Clone the template content
    const clone = template.content.cloneNode(true);

    // Find the <side-cart-item> element within the cloned template
    const element = clone.querySelector('side-cart-item');

    // Set attributes dynamically based on context.item
    const item = context.item;
    element.setAttribute('variant-id', item.id);
    element.setAttribute('item-count', item.quantity);
    if (item.key) element.setAttribute('line-item-key', item.key);

    // You can also update inner text or other DOM parts here if needed
    const hasVariantTitle = !!(item.variant_title && item.variant_title !== 'Default Title');
    const variantHtml = hasVariantTitle ? `<span>- ${item.variant_title}</span>` : '';

    element.innerHTML = element.innerHTML
      .replace(
        /\$\$IMAGE_URL\$\$/g,
        item.featured_image && item.featured_image.url ? item.featured_image.url + '&width=200' : ''
      )
      .replace(/\$\$IMAGE_ALT\$\$/g, item.featured_image && item.featured_image.alt ? item.featured_image.alt : '')
      .replace(/\$\$ITEM_URL\$\$/g, item.url)
      .replace(/\$\$ITEM_TITLE\$\$/g, item.product_title)
      // .replace(
      //   /\$\$ITEM_PRICE\$\$/g,
      //   Shopify.formatMoney(item.final_line_price, '{{ amount_no_decimals_with_currency }}')
      // )
      // .replace(/\$\$ITEM_PRICE\$\$/g, Shopify.formatMoney(item.final_line_price))
      .replace(/\$\$ITEM_PRICE\$\$/g, Shopify.formatMoney(item.final_line_price, 'DKK {{amount_with_comma_separator}}'))
      .replace(/\$\$ITEM_QUANTITY\$\$/g, item.quantity)
      .replace(/\$\$ITEM_VARIANT_HTML\$\$/g, variantHtml);

    return clone;
  }

  getCart() {
    // console.log('getCart Called!!!');

    fetch(window.Shopify.routes.root + 'cart.js')
      .then((response) => response.json())
      .then((cart) => {
        // console.log(cart);
        this.cart = cart;
        this.buildCart(cart);
      });
  }

  buildCart(cart) {
    const cartItems = this.querySelector('#cart-items');
    if (!cartItems) {
      console.error('#cart-items element not found');
      return;
    }

    // Ryd JS container
    cartItems.innerHTML = '';

    // Ryd tom kurv besked
    const cartEmpty = this.querySelector('.empty-cart-message');
    // cartEmpty.innerHTML = '';
    // cartEmpty.style.display = 'none';

    // Ryd Liquid container helt for at undgå flash af "empty cart"
    const liquidContainer = this.querySelector('#cart-items-liquid');
    if (liquidContainer) {
      liquidContainer.innerHTML = '';
      liquidContainer.style.display = 'none';
    }

    // Defensive: ignore any zero-qty lines if they appear transiently in AJAX response
    const itemsList = (cart.items || []).filter((i) => (i?.quantity ?? 0) > 0);

    // Håndter tom kurv
    if (itemsList.length === 0) {
      const i18n = window.__cartI18n || {};
      const title = i18n.empty_title || 'Your cart is empty.';
      const intro = i18n.empty_intro || "Don't know where to start?";
      const cta = i18n.empty_cta || 'Explore our collections.';
      cartItems.innerHTML = `
      <div class="empty-cart-message-js">
        <h5>${title}</h5>
        <p>${intro}</p>
        <p>${cta}</p>
      </div>
    `;
    } else {
      // Fyld JS container med varer
      itemsList.forEach((item) => {
        const fragment = this.renderSideCartItem({ item });
        cartItems.appendChild(fragment);
      });
    }

    // Find korrekt summary-container (drawer vs. main-cart sidekolonne)
    const inDrawer = !!this.drawer;
    let summaryRoot = null;
    if (inDrawer) {
      summaryRoot = this.drawer;
    } else {
      const pageRoot = this.closest('.main-cart-content');
      summaryRoot = pageRoot ? pageRoot.querySelector('.cart-summary') : document.querySelector('.cart-summary');
    }

    if (summaryRoot) {
      // Opdater shipping-progress (scoped)
      const freeShippingGoal = 40000;
      const shippingText = summaryRoot.querySelector('.shipping-text');
      const rangeBar = summaryRoot.querySelector('.range-bar');
      if (shippingText && rangeBar) {
        const total = cart.total_price || 0;
        const remaining = freeShippingGoal - total;

        // Lokaliserede labels fra DOM (sat via Liquid data-attributes)
        const shippingAmountRoot = shippingText.closest('.shipping-amount') || summaryRoot;
        const tOnly = shippingAmountRoot?.dataset.onlyLabel || 'Only';
        const tForFree = shippingAmountRoot?.dataset.forFreeShippingLabel || 'to receive free shipping';
        const tFree = shippingAmountRoot?.dataset.freeShipping || 'You have free shipping!';

        if (remaining > 0) {
          shippingText.innerHTML = `${tOnly} <span>${Shopify.formatMoney(
            remaining,
            'DKK {{amount_with_comma_separator}}'
          )}</span> ${tForFree}`;
        } else {
          // behold <span> så styling altid gælder
          shippingText.innerHTML = `<span>${tFree}</span>`;
        }

        const percent = Math.min((total / freeShippingGoal) * 100, 100);
        rangeBar.style.width = percent + '%';
      }

      // Opdater order value (kun i main-cart)
      const orderValueEl = summaryRoot.querySelector('.order-value p:last-child');
      if (orderValueEl) {
        const formattedOrder = Shopify.formatMoney(cart.total_price, 'DKK {{amount_with_comma_separator}}');
        orderValueEl.textContent = formattedOrder;
      }

      // Opdater totalpris (scoped)
      const cartTotalEl = summaryRoot.querySelector('#cart-total');
      if (cartTotalEl) {
        const formattedTotal = Shopify.formatMoney(cart.total_price, 'DKK {{amount_with_comma_separator}}');
        cartTotalEl.innerHTML = `<p>Total</p><p>${formattedTotal}</p>`;
      }

      // Opdater checkout-knap (scoped)
      const checkoutBtn = summaryRoot.querySelector('#checkout-btn');
      if (checkoutBtn) {
        if (itemsList.length === 0) {
          checkoutBtn.href = '/collections/all';
          checkoutBtn.textContent = 'Explore Collections';
        } else {
          checkoutBtn.href = '/checkout';
          checkoutBtn.textContent = 'Checkout';
        }
      }
    }

    this.classList.add('loaded');

    // Drawer åbning/lukning
    if (this.drawer) {
      const panel = this.drawer.querySelector('.sd-panel');
      const overlay = this.drawer.querySelector('.sd-overlay');
      if (panel && overlay) {
        // Open with scroll lock if helper available
        if (typeof this.drawer.openSidecart === 'function') {
          this.drawer.openSidecart();
        } else {
          panel.classList.add('is-open');
          overlay.classList.add('is-open');
        }

        // Bind close handlers once per drawer instance
        if (!this._drawerBound) {
          const closeBtn = this.drawer.querySelector('.sd-close-btn');
          const close = () => {
            if (typeof this.drawer.closeSidecart === 'function') {
              this.drawer.closeSidecart();
            } else {
              panel.classList.remove('is-open');
              overlay.classList.remove('is-open');
            }
          };
          if (closeBtn) closeBtn.addEventListener('click', close);
          if (overlay) overlay.addEventListener('click', close);
          this._drawerBound = true;
        }
      }
    }

    const upsell = document.getElementById('cart-upsell-liquid');
    if (upsell) {
      // Tjek om der er mindst ét synligt upsell-produkt
      const hasUpsell = upsell.querySelector('.cart-upsell') !== null;
      if (hasUpsell) {
        upsell.style.display = 'grid';
      } else {
        upsell.style.display = 'none';
      }
    }

    // Opdater upsell-knapper
    document.querySelectorAll('.cart-upsell').forEach((box) => {
      const handle = box.dataset.productHandle;
      const btn = box.querySelector('.cart-upsell-btn');
      const inCart = cart.items.some((item) => item.handle === handle);

      if (inCart) {
        btn.innerText = 'Added';
        btn.disabled = true;
      } else {
        btn.innerText = 'Add';
        btn.disabled = false;
      }
    });

    // checkout-knap opdateres allerede via summaryRoot ovenfor

    const cartCountSpan = document.getElementById('current-cart-items');
    if (cartCountSpan) {
      if (cart.item_count > 0) {
        cartCountSpan.textContent = `(${cart.item_count})`;
      } else {
        cartCountSpan.textContent = '';
      }
    }

    const mobileCartCountSpan = document.getElementById('mobile-current-cart-items');
    if (mobileCartCountSpan) {
      if (cart.item_count > 0) {
        mobileCartCountSpan.textContent = `(${cart.item_count})`;
      } else {
        mobileCartCountSpan.textContent = '';
      }
    }

    const sidecartCountSpan = document.getElementById('sidecart-current-cart-items');
    if (sidecartCountSpan) {
      if (cart.item_count > 0) {
        sidecartCountSpan.textContent = `(${cart.item_count})`;
      } else {
        sidecartCountSpan.textContent = '';
      }
    }

    // console.log('cart price', cart.total_price);
  }

  addLineItem(line_item) {
    // Vis loader
    this.classList.remove('loaded');
    // Hent hele kurven igen fra Shopify for at sikre korrekt totalpris og tilbud
    this.getCart();
  }
}

customElements.define('side-cart', SideCart);
